import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const resourceSentence = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    sentence: z.string().nullable().optional().describe('Sentence'),

    word: z.string().nullable().optional().describe('Word'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Sequence - Display order'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    resourceId: z.number().hidden().describe('Foreign key to Resource'),

    resource: belongsTo('Resource'),
  })
  .describe('One sentence of a click-the-word or fill-in-the-blank resource.')
  .as('ResourceSentence');

export { resourceSentence as resourceSentenceSchema };
